module.exports = __webpack_public_path__ + "5eef227076666b95bcd8be87c9a8dd12.MP3";